import { IconButton, Tooltip } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PortalModal from "../../Portals";
import {
  ButtonOk,
  CloseModal,
  ContentAnswer,
  ContentModal,
  TextModal,
} from "./ModalResumeModal.styled";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { Col, Row } from "react-bootstrap";
import { ANSWERS_PREVIEW_BY_SURVEY_ID } from "../../GraphQL/Queries";
import { useLazyQuery } from "@apollo/client";
import { isNonEmptyArray } from "@apollo/client/utilities";
import { theme as themeConfig } from "../../themes/themes";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import UploadResumeComponent from "../UploadResumeComponent";

const ModalResumeModal = ({ open, setOpen }) => {
  const [data, setData] = useState();
  const [
    runQueryAnswersPreviewBySurveyId,
    { loading: loadingFirst, error: errorFirst },
  ] = useLazyQuery(ANSWERS_PREVIEW_BY_SURVEY_ID, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      if (data) {
        setData({ ...data.answersPreviewBySurveyId });
      } else {
        setData();
      }
    },
  });

  useEffect(() => {
    if (open) {
      runQueryAnswersPreviewBySurveyId({
        variables: {
          surveyId: open,
        },
      });
    }
  }, [open]);

  return (
    <PortalModal>
      <ContentModal>
        <CloseModal>
          <Tooltip title="close">
            <IconButton onClick={() => setOpen(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModal>
        <TextModal>
          {loadingFirst && !errorFirst && (
            <Row>
              <Col md="12" className="d-flex justify-content-center">
                <PointersLine color={themeConfig.text.primary} />
              </Col>
            </Row>
          )}
          {!loadingFirst && errorFirst && (
            <Row>
              <Col md="12" className="d-flex justify-content-center">
                <h1>Error :(</h1>
              </Col>
            </Row>
          )}
          {isNonEmptyArray(data?.tpsurveyAnswerClients) &&
            !loadingFirst &&
            !errorFirst &&
            data?.tpsurveyAnswerClients.map((item, index) => (
              <ContentAnswer key={index}>
                <p>{++index + " " + item.idQuestionNavigation.nameQuestion} </p>
                <UploadResumeComponent
                  answer={item.answerClient}
                ></UploadResumeComponent>
              </ContentAnswer>
            ))}
        </TextModal>
        <Row className="justify-content-end w-100">
          <Col md="4">
            <ButtonOk onClick={() => setOpen(null)}>OK</ButtonOk>
          </Col>
        </Row>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalResumeModal;
